import { put } from 'redux-saga/effects';
import { SET_ERROR } from '../store/constants/actionTypes';
import * as errorCodes from '../store/constants/errorCodes';
import { translate as _ } from './i18n';
import { showMessage } from './ui';

const messages = {

    [ errorCodes.GENERAL_ERROR                ]: _( 'Allgemeiner Fehler.' ),
    [ errorCodes.LOADING_ERROR                ]: _( 'Fehler beim Laden.' ),
    [ errorCodes.LOGIN_ERROR                  ]: _( 'Login fehlgeschlagen. Benutzername und/oder Passwort ungültig.' ),
    [ errorCodes.LOGOUT_ERROR                 ]: _( 'Logout fehlgeschlagen.' ),
    [ errorCodes.RESET_PASSWORD_ERROR         ]: _( 'Passwort konnte nicht zurückgesetzt werden. Der verwendete Token ist nicht mehr gültig.' ),
    [ errorCodes.SEND_PASSWORD_RECOVERY_ERROR ]: _( 'E-Mail konnte nicht gesendet werden. Bitte überprüfe deinen Benutzernamen.' )

};

export const error = ( code = errorCodes.GENERAL_ERROR ) => {

    if ( ! ( code in messages ) ) {

        throw new Error( 'Invalid Error Code "' + code + '".' );

    }

    return { code };

};

export function* loadingError( actionType, errorCode = errorCodes.LOADING_ERROR, payload, message ) {

    yield put( { type: actionType, payload } );

    if ( errorCode !== null ) {

        yield put( { type: SET_ERROR, payload: { error: error( errorCode ) } } );

    }

    if ( message ) {

        showMessage( { message } );

    }

}

export const getErrorMessage = ( code ) => {

    return ( ( code in messages ) ? _( messages[ code ] ) : '' );

};